<p-button
  type="button"
  [ariaLabel]="label()"
  [attr.aria-disabled]="isDisabled()"
  [attr.role]="'button'"
  [attr.tabindex]="isDisabled() ? -1 : 0"
  [autofocus]="autofocus()"
  [disabled]="isDisabled()"
  [dt]="dt()"
  [icon]="iconClass()"
  [iconPos]="iconPos()"
  [label]="label()"
  [link]="isLink()"
  [loading]="loading()"
  [outlined]="type() === sharedButtonType.Outline"
  [pt]="pt()"
  [severity]="severity()"
  [size]="size()"
  [text]="type() === sharedButtonType.TextLink"
  (onClick)="onClick($event)">
</p-button>
